import search from './search';

function initModal() {
  $('body').on('click', '.sh-modal-open', function (e) {
    e.preventDefault();
    var modalId = $(this).data('modal-id');
    $('#' + modalId).css('display', 'flex');
    $('body').addClass('sh-modal-open');

    if (this.hasAttribute('data-modal-title'))
      $('#' + modalId).find('.sh-modal-title').html($(this).data('modal-title'));

    if (this.hasAttribute('data-modal-content'))
      $('#' + modalId).find('.sh-modal-content').html(JSON.parse($(this).data('modal-content')));

  });

  $('.sh-modal-close').on('click', function () {
    var modalId = $(this).data('modal-id');
    $('#' + modalId).css('display', 'none');
    $('body').removeClass('sh-modal-open');
  });

  $('.sh-modal').on('click', function (event) {
    if (event.target === this) {
      $(this).css('display', 'none');
      $('body').removeClass('sh-modal-open');
    }
  });
}

function initTooltip() {
  const manualTooltips = $('[data-toggle="tooltip"][data-tooltip-trigger="manual"]');

  manualTooltips.tooltip({
    trigger: 'manual',
  });

  $('[data-toggle="tooltip"][data-tooltip-trigger!="manual"]').tooltip({});

  $('body').on('mouseleave', '.tooltip', function () {
    manualTooltips.tooltip('hide');
  });

  manualTooltips.on('mouseenter', function (e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    $(this).tooltip('show');
  });

  manualTooltips.on('click', function (e) {
    if (!$(this).hasClass('sh-slide')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
    }
    $(this).tooltip('show');
  });


  $(document).click(function (e) {
    if ($(e.target).closest('.sh-tooltip.show').length === 0) {
      manualTooltips.tooltip('hide');
    }
  });


}

function initAccordions() {
  $('.sh-accordion-head').on('click', function () {
    $(this).closest('.sh-accordion').toggleClass('sh-closed');
  })
}

function initExpander() {
  $('body').on('click', '.sh-expand-more', function (e) {
    e.preventDefault();
    $(this).closest('.sh-expand-more-content').html(JSON.parse($(this).data('content')));
  });
}

export default {
  init: function () {
    initModal();
    initTooltip();
    initAccordions();
    initExpander();
    search.init();
  },
  finalize() {

  },
};
